// modules/expanding-cards-swiper.js

/**  Inizializza lo Swiper per le expanding-cards, attivato solo su mobile (<992px)
 * - Attiva/disattiva lo swiper al ridimensionamento della finestra
 * - Usa la variabile globale window.innerWidth
 * - Dal CSS/SCSS viene gestita la visibilità dello Swiper → breakpoint 992px
 * - Controlla se Swiper è definito
 * - Logga messaggi utili per debug
 */

let expSwiper = null;

export function initExpandingCardsSwiper() {
	// Controlla se Swiper e GLightbox sono definiti
	if (typeof Swiper === "undefined") {
		console.warn(" Swiper non è disponibile");
		return;
	}

	const grids = document.querySelectorAll("[data-expanding-cards]");
	if (!grids.length) {
		console.warn(
			"Swiper è disponibile ma nessuna sezione 'expanding-cards' è stata trovata in questa pagina"
		);
		return;
	}

	const enableSwiper = (grid, postId) => {
		expSwiper = new Swiper(grid, {
			slidesPerView: 1,
			spaceBetween: 16,
			loop: false,
			speed: 1000,
			// autoplay: {
			// 	delay: 3000,
			// 	disableOnInteraction: false,
			// 	pauseOnMouseEnter: true,
			// },
			pagination: {
				el: grid.querySelector(`.swiper-pagination-${postId}`),
				clickable: true,
			},
		});
		console.log("[expanding-cards] Swiper attivato");
	};

	const destroySwiper = () => {
		if (expSwiper) {
			expSwiper.destroy(true, true);
			expSwiper = null;
			console.log("[expanding-cards] Swiper distrutto");
		}
	};

	const checkViewport = () => {
		// Attiva lo swiper solo su mobile (<992px)
		// Disattiva lo swiper su desktop (>=992px)
		// Usa la variabile globale window.innerWidth
		// Dal CSS/SCSS viene gestita la visibilità dello Swiper → breakpoint 992px
		if (window.innerWidth < 992) {
			grids.forEach((grid) => {
				const postId = grid.dataset.postid;
				console.log("Post ID -> ", postId, grid);
				if (!expSwiper) enableSwiper(grid, postId);
			});
		} else {
			destroySwiper();
		}
	};

	checkViewport();
	window.addEventListener("resize", checkViewport);
}
